import _toConsumableArray from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { LevelState } from "../state";
import { FilterBasedAccessor } from "./FilterBasedAccessor";
import { TermQuery, TermsBucket, FilterBucket, BoolMust, NestedQuery, NestedBucket, MinMetric, DefaultNumberBuckets } from "../query";

var map = require("lodash/map");

var get = require("lodash/get");

var includes = require("lodash/includes");

var startsWith = require("lodash/startsWith");

var each = require("lodash/each");

var take = require("lodash/take");

export var NestedFacetAccessor =
/*#__PURE__*/
function (_FilterBasedAccessor) {
  _inherits(NestedFacetAccessor, _FilterBasedAccessor);

  function NestedFacetAccessor(key, options) {
    var _this;

    _classCallCheck(this, NestedFacetAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NestedFacetAccessor).call(this, key, options.id));
    _this.state = new LevelState();
    _this.options = options;
    return _this;
  }

  _createClass(NestedFacetAccessor, [{
    key: "onResetFilters",
    value: function onResetFilters() {
      this.resetState();
    }
  }, {
    key: "getBuckets",
    value: function getBuckets(level) {
      var buckets = this.getAggregations([this.key, "children", "lvl" + level, "children", "buckets"], []);
      return map(buckets, function (item) {
        item.key = String(item.key);
        return item;
      });
    }
  }, {
    key: "buildSharedQuery",
    value: function buildSharedQuery(query) {
      var _this2 = this;

      var levelFilters = this.state.getValue();
      var lastIndex = levelFilters.length - 1;
      var filterTerms = map(levelFilters, function (filter, i) {
        var value = filter[0];
        var isLeaf = i === lastIndex;
        var subField = isLeaf ? ".value" : ".ancestors";
        return TermQuery(_this2.options.field + subField, value);
      });

      if (filterTerms.length > 0) {
        var leafFilter = get(levelFilters, [levelFilters.length - 1, 0], "");
        var parentOfleaf = get(levelFilters, [levelFilters.length - 2, 0], this.options.title || this.key);
        var selectedFilter = {
          id: this.key,
          name: this.translate(parentOfleaf),
          value: leafFilter,
          remove: function remove() {
            _this2.state = _this2.state.clear(levelFilters.length - 1);
          }
        };
        query = query.addFilter(this.uuid, NestedQuery(this.options.field, BoolMust(filterTerms))).addSelectedFilter(selectedFilter);
      }

      return query;
    }
  }, {
    key: "getTermAggs",
    value: function getTermAggs() {
      var subAggs = undefined;
      var orderMetric = undefined;

      if (this.options.orderKey) {
        var orderDirection = this.options.orderDirection || "asc";
        var orderKey = this.options.orderKey;

        if (includes(["_count", "_term"], orderKey)) {
          orderMetric = _defineProperty({}, orderKey, orderDirection);
        } else {
          if (startsWith(orderKey, this.options.field + ".")) {
            var subAggName = this.options.field + "_order";
            orderMetric = _defineProperty({}, subAggName, orderDirection);
            subAggs = MinMetric(subAggName, orderKey);
          }
        }
      }

      var valueField = this.options.field + ".value";
      var nBuckets = this.options.size || DefaultNumberBuckets;
      return TermsBucket("children", valueField, {
        size: nBuckets,
        order: orderMetric
      }, subAggs);
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      var levelField = this.options.field + ".level";
      var ancestorsField = this.options.field + ".ancestors";
      var startLevel = this.options.startLevel || 1;
      var termAggs = this.getTermAggs();
      var lvlAggs = [];

      var addLevel = function addLevel(level) {
        var ancestors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        lvlAggs.push(FilterBucket("lvl" + level, BoolMust([TermQuery(levelField, level + startLevel)].concat(_toConsumableArray(ancestors))), termAggs));
      };

      addLevel(0);
      var levels = this.state.getValue();
      each(levels, function (_level, i) {
        var ancestors = map(take(levels, i + 1), function (level) {
          return TermQuery(ancestorsField, level[0]);
        });
        addLevel(i + 1, ancestors);
      });
      return query.setAggs(FilterBucket(this.key, query.getFiltersWithoutKeys(this.uuid), NestedBucket.apply(void 0, ["children", this.options.field].concat(lvlAggs))));
    }
  }]);

  return NestedFacetAccessor;
}(FilterBasedAccessor);